export enum ContractType {
  ELECTRICITYGAS = 'electricityGas',
  ELECTRICITY = 'electricity'
}
